import { capitalCase } from 'change-case';

const EXACT_FINANCIAL_LABELS: Readonly<Record<string, string>> = {
    ebit: 'EBIT',
    ebitda: 'EBITDA',
    ebitdaratio: 'EBITDA Ratio',
    eps: 'EPS',
    epsdiluted: 'Diluted EPS',
    rdexpense: 'R&D Expense',
    sgaexpenses: 'SG&A Expenses',
    weightedAverageShares: 'Weighted Average Shares Outstanding',
    weightedAverageSharesDiluted: 'Diluted Weighted Average Shares Outstanding',
    weightedAverageSharesOutstanding: 'Weighted Average Shares Outstanding',
    weightedAverageSharesOutstandingDiluted: 'Diluted Weighted Average Shares Outstanding',
    weightedAverageShsOut: 'Weighted Average Shares Outstanding',
    weightedAverageShsOutDil: 'Diluted Weighted Average Shares Outstanding',
};

const RESERVED_FINANCIAL_TERMS: ReadonlyArray<readonly [RegExp, string]> = [
    [/\bEbitda\b/g, 'EBITDA'],
    [/\bEbit\b/g, 'EBIT'],
    [/\bEps\b/g, 'EPS'],
    [/\bEbt\b/g, 'EBT'],
    [/\bCik\b/g, 'CIK'],
    [/\bCf\b/g, 'Cash Flow'],
    [/\bCapex\b/g, 'CapEx'],
    [/\bRdexpense\b/g, 'R&D Expense'],
    [/\bSgaexpenses\b/g, 'SG&A Expenses'],
    [/\bTen Y\b/g, '10Y'],
    [/\bFive Y\b/g, '5Y'],
    [/\bThree Y\b/g, '3Y'],
    [/\bPer\b/g, 'per'],
];

const humanizeFinancialKey = (key: string) => {
    const exactLabel = EXACT_FINANCIAL_LABELS[key];

    if (exactLabel) {
        return exactLabel;
    }

    const spacedKey = key
        .replace(/per(?=[A-Z])/g, ' per ')
        .replace(/[_-]+/g, ' ')
        .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
        .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
        .replace(/\s+/g, ' ')
        .trim();

    return RESERVED_FINANCIAL_TERMS.reduce(
        (label, [pattern, replacement]) => label.replace(pattern, replacement),
        capitalCase(spacedKey),
    );
};

export const formatFinancialLineItemLabel = (key: string) => {
    const normalizedKey = key.trim();

    if (!normalizedKey) {
        return '';
    }

    if (/^growth[A-Z]/.test(normalizedKey)) {
        return `${humanizeFinancialKey(normalizedKey.slice('growth'.length))} Growth`;
    }

    if (/growth$/i.test(normalizedKey)) {
        return `${humanizeFinancialKey(normalizedKey.replace(/growth$/i, ''))} Growth`;
    }

    return humanizeFinancialKey(normalizedKey);
};

export default formatFinancialLineItemLabel;
